(() => {
  const root = document.querySelector('[data-pbn-landing-pilot]');
  const sticky = root?.querySelector('.dam-v10-standard-sticky');
  if (!sticky) return;

  const hosts = new Set();
  const syncHeight = () => {
    for (const host of hosts) {
      host.style.setProperty('--dam-pdp-sticky-height', `${Math.ceil(sticky.getBoundingClientRect().height)}px`);
    }
  };
  const mount = () => {
    for (const host of document.querySelectorAll('shopify-forms-embed')) {
      if (!host.shadowRoot || hosts.has(host)) continue;
      const style = document.createElement('style');
      style.dataset.damPdpTeaserClearance = '';
      style.textContent = '@media(max-width:760px){#app-embed[data-current-step="tease"][data-position="bottom-right"]{bottom:calc(var(--dam-pdp-sticky-height,68px) + 8px)!important}}';
      host.shadowRoot.append(style);
      hosts.add(host);
    }
    syncHeight();
  };
  const observer = new MutationObserver(mount);
  observer.observe(document.body, {childList: true, subtree: true});
  customElements.whenDefined('shopify-forms-embed').then(mount);
  new ResizeObserver(syncHeight).observe(sticky);
  mount();
  window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
})();
